import { alpha, Box, Button, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { toggleTeleHealthTherapy } from 'src/services/telehealth.service';
import Iconify from '../iconify';
import DeleteDialog from './delete-therapy-package';

export default function TeleHealthPackageCard({ cardDetails }) {
  const router = useRouter();
  const {
    id,
    clinic_id,
    therapy_name,
    promo_image,
    is_active,
  } = cardDetails;


  const onClickActivate = () => {
    toggleTeleHealthTherapy(id, clinic_id, { is_active: true }).then(() => {
      router.reload();
    });
  };

  const onClickDeactivate = () => {
    toggleTeleHealthTherapy(id, clinic_id, { is_active: false }).then(() => {
      router.reload();
    });
  };

  return (
    <Box sx={{ background: 'white', padding: 3, borderRadius: 2 }}>
      {promo_image ? (
        <img
          src={promo_image}
          alt="Therapy Promo"
          style={{ borderRadius: '14px', width: '100%' }}
        />
      ) : (
        <Box
          sx={{
            height: 140,
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
            border: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        />
      )}

      <Stack direction="row" justifyContent="space-between" alignItems="center" marginY="6px">
        <Typography fontSize={{ lg: '16px', xs: '12px' }}>
          {therapy_name}
        </Typography>

        <Stack direction="row">
          <IconButton
            onClick={() => {
              router.push(
                paths.clinic_dashboard.edit_telehealth.replace(':therapyId', id)
              );
            }}
          >
            <Iconify icon="tabler:edit" />
          </IconButton>
          <DeleteDialog therapyId={id} clinicId={clinic_id} />

        </Stack>
      </Stack>

      {is_active ? (
        <Button
          variant="outlined"
          onClick={onClickDeactivate}
          sx={{
            width: 1,
            borderColor: '#D92D7F',
            color: '#D92D7F',
            fontSize: { lg: '16px', xs: '12px' },
          }}
        >
          Deactivate
        </Button>
      ) : (
        <Button
          variant="outlined"
          onClick={onClickActivate}
          sx={{
            width: 1,
            color: 'white',
            boxShadow: 10,
            background: '#D92D7F',
            ':hover': { background: '#D92D7F' },
            fontSize: { lg: '16px', xs: '12px' },
          }}
        >
          Activate
        </Button>
      )}
    </Box>
  );
}
